import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/components/FilterPanel/components/SelectSourcePanel/createSelectSourcePanel.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import { combine } from 'effector';
import { isNotEmpty } from '@gmini/utils';
import { PlusCircle } from '@gmini/ui-kit';
import { useStore } from 'effector-react';
import { memo } from 'react';
import { renderNodeIcon } from "../../utils/renderNodeIcon";
import { getNode } from "../../../../classifier-service";
import { SourceItem } from "../SourceItem";
import { isBaseClassifierNode, isBimCategoryReferenceNode, isBimElementNode, isBimElementReferenceNode, isBimFamilyReferenceNode, isBimModelReferenceNode, isBimStandardSizeReferenceNode, isDynamicBimElementReferenceNode } from "../../../../classifier-service/Node";
import { getDepNumberByRef } from "../../utils/getDepNumberByRef";
import { getReferenceByNode } from "../../utils/getReferenceByNode";
import { Container, AddButton, ScrollableSourceList } from "./SelectSourcePanel.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function createSelectSourcePanel(_ref) {
  var checkedModel = _ref.checkedModel,
      nodes$ = _ref.nodes$,
      sources = _ref.sources,
      currentEntity$ = _ref.currentEntity$;
  var selectedSourceNodes$ = combine({
    ɔ: [{
      nodes$: nodes$,
      checkedNodes$: checkedModel.checked$,
      currentEntity$: currentEntity$
    }, function (_ref2) {
      var checkedNodes = _ref2.checkedNodes$,
          nodes = _ref2.nodes$,
          currentEntity = _ref2.currentEntity$;
      return Object.entries(checkedNodes).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            _ = _ref4[0],
            value = _ref4[1];

        return value;
      }).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            key = _ref6[0];

        var keys = key.split(':');

        var _keys$split = keys[keys.length - 1].split('_'),
            _keys$split2 = _slicedToArray(_keys$split, 2),
            type = _keys$split2[0],
            id = _keys$split2[1];

        var ref = {
          id: parseInt(id, 10),
          type: type
        };

        if (ref.type === 'BimElementNode' || ref.type === 'BimElementReferenceNode') {
          return null;
        }

        var node = getNode(nodes, ref);

        if (ref.type === 'BimModelReferenceNode') {
          var modelNode = getModelNodeByRef(nodes, ref);

          if (modelNode) {
            node = modelNode;
          }
        }

        if (!node || isBaseClassifierNode(node) || isBimModelReferenceNode(node) || isBimModelReferenceNode(node) || isBimCategoryReferenceNode(node) || isBimModelReferenceNode(node) || isBimFamilyReferenceNode(node) || isBimStandardSizeReferenceNode(node) || isBimElementReferenceNode(node) || isDynamicBimElementReferenceNode(node) || isBimElementNode(node)) {
          return null;
        }

        return {
          id: node.id,
          type: node.type,
          name: node.name,
          depNumber: getDepNumberByRef(getReferenceByNode(nodes, node), currentEntity)
        };
      }).filter(isNotEmpty);
    }],
    config: {
      name: "selectedSourceNodes$",
      sid: "5qf2y8"
    }
  });
  var SelectSourcePanel = /*#__PURE__*/memo(function () {
    var selectedSourceNodes = useStore(selectedSourceNodes$, {
      loc: {
        file: _effectorFileName,
        line: 129,
        column: 32
      },
      name: "SelectSourcePanel",
      sid: "SelectSourcePanel /src/components/FilterPanel/components/SelectSourcePanel/createSelectSourcePanel.tsx [129, 32]"
    });
    var checked = useStore(checkedModel.checked$, {
      loc: {
        file: _effectorFileName,
        line: 130,
        column: 20
      },
      name: "SelectSourcePanel",
      sid: "SelectSourcePanel /src/components/FilterPanel/components/SelectSourcePanel/createSelectSourcePanel.tsx [130, 20]"
    });
    var nodes = useStore(nodes$, {
      loc: {
        file: _effectorFileName,
        line: 131,
        column: 18
      },
      name: "SelectSourcePanel",
      sid: "SelectSourcePanel /src/components/FilterPanel/components/SelectSourcePanel/createSelectSourcePanel.tsx [131, 18]"
    });
    return /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(ScrollableSourceList, {
        children: selectedSourceNodes.map(function (source, idx) {
          //Эта конструкция будет работать только в зависимостях. В редакторе будет вероятность пересечения ключей, если пользователь выберет одинаковые элементы
          var keyNode = "".concat(source.type, "_").concat(source.id);
          var checkedKey = Object.keys(checked).find(function (key) {
            var splittedKey = key.split(':');
            var lastKey = splittedKey[splittedKey.length - 1];

            var _lastKey$split = lastKey.split('_'),
                _lastKey$split2 = _slicedToArray(_lastKey$split, 2),
                type = _lastKey$split2[0],
                id = _lastKey$split2[1];

            var ref = {
              id: Number(id),
              type: type
            };

            if (ref.type === 'BimModelReferenceNode') {
              var modelNode = getModelNodeByRef(nodes, ref);

              if (modelNode) {
                return [modelNode.type, modelNode.id].join('_') === keyNode;
              }
            }

            return lastKey === keyNode;
          });
          return /*#__PURE__*/_jsx(SourceItem, {
            icon: renderNodeIcon(source.type),
            onRemove: function onRemove() {
              checkedModel.removeChecked(checkedKey);
            },
            source: source
          }, source.id);
        })
      }), /*#__PURE__*/_jsx(AddButton, {
        leftIcon: /*#__PURE__*/_jsx(PlusCircle, {
          color: "#fff"
        }),
        onClick: function onClick() {
          return sources.add(selectedSourceNodes);
        },
        color: "info",
        children: "\u0412 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u043E\u0438\u0441\u043A\u0430"
      })]
    });
  });
  SelectSourcePanel.displayName = 'SelectSourcePanel';
  return {
    SelectSourcePanel: SelectSourcePanel,
    selectedSourceNodes$: selectedSourceNodes$
  };
}
export var getModelNodeByRef = function getModelNodeByRef(nodes, ref) {
  if (ref.type === 'BimModelReferenceNode') {
    var referenceBimModel = nodes.ReferenceNode[ref.id];

    if (referenceBimModel) {
      return getNode(nodes, {
        type: 'BimModelNode',
        id: referenceBimModel.element.id
      });
    }
  }
};